import { Component, computed, input, output, signal } from '@angular/core';
import {
  GcButtonComponent,
  GcInputFieldComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-bom-comment-form',
  imports: [GcInputFieldComponent, GcButtonComponent, IpoTranslatePipe],
  templateUrl: './bom-comment-form.component.html',
  styleUrl: './bom-comment-form.component.scss',
})
export class BomCommentFormComponent {
  isSaving = input(false);

  confirmed = output<string>();
  cancelled = output<void>();

  readonly comment = signal('');
  readonly canConfirm = computed<boolean>(
    () => this.comment().trim().length > 0,
  );

  onCommentChanged(comment: string): void {
    this.comment.set(comment);
  }

  onConfirm(): void {
    if (!this.canConfirm() || this.isSaving()) {
      return;
    }
    this.confirmed.emit(this.comment().trim());
  }
}
